module.exports = __webpack_public_path__ + "static/cer_dor_1-33303c88dceb91f31c415177c24b21cb.jpg";